import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import PartnerPage from "./pages/PartnerPage";
import "./styles/global.scss";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/partner" element={<PartnerPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
